import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MetaService } from '../meta.service';
@Component({
  selector: 'app-creative-design',
  templateUrl: './creative-design.component.html',
  styleUrls: ['./creative-design.component.scss']
})
export class CreativeDesignComponent implements OnInit {
  title = 'Transform Your Online Presence: Creative Web Designing Services for Stunning Websites';
  constructor(
    private titleService: Title, 
    private metaService: MetaService,
    private meta: Meta
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.meta.updateTag(
      { name: 'description', content: "Our creative web designing services combine cutting-edge design techniques with strategic thinking to create visually stunning and engaging websites." }
    );
    this.metaService.createCanonicalURL();
  }

}
